import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const navLinks = [
  { label: 'TOP', href: '/' },
  { label: 'ICON治療', href: '#about' },
  { label: '治療の流れ', href: '#steps' },
  { label: '料金', href: '#pricing' },
  { label: '医師紹介', href: '#doctor' },
  { label: 'FAQ', href: '#faq' },
  { label: 'アクセス', href: '#access' },
];

const RESERVATION_URL = 'https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb';
const LOGO_URL =
  'https://storage.readdy-site.link/project_files/c00d6376-89f2-4ee7-9f33-9907e12ecb61/5c4cba08-7521-4652-9010-b7f70fefc08a_logo_rgb.jpg?v=3480add82bc20e03476af8760bccaa52';

export default function IconHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAnchorClick = (href: string) => {
    setMenuOpen(false);
    if (href.startsWith('#')) {
      const id = href.slice(1);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(href);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* ロゴ */}
          <a
            href="https://saiwaidental.jp/moyuk"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 cursor-pointer"
          >
            <img
              alt="さいわいデンタルクリニック"
              className="h-8 md:h-10 w-auto object-contain"
              src={LOGO_URL}
            />
          </a>

          {/* デスクトップナビ */}
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleAnchorClick(link.href);
                }}
                className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-gray-900 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* 右側：電話 + 予約 + ハンバーガー */}
          <div className="flex items-center gap-4">
            {/* 電話（デスクトップ） */}
            <div className="hidden md:flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="fa-solid fa-phone text-xl text-gray-700"></i>
              </div>
              <div className="text-left">
                <a
                  href="tel:05018094594"
                  className="block font-bold text-sm hover:underline cursor-pointer whitespace-nowrap text-gray-900"
                >
                  050-1809-4594
                </a>
                <p className="text-xs whitespace-nowrap text-gray-600">
                  10:00~19:00(最終受付18:00)
                </p>
                <p className="text-xs font-medium whitespace-nowrap" style={{ color: '#3E5F8F' }}>
                  ご相談予約
                </p>
              </div>
            </div>

            {/* WEB予約（デスクトップ） */}
            <a
              href={RESERVATION_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:block text-white px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer hover:opacity-90"
              style={{ backgroundColor: '#3E5F8F' }}
            >
              ご相談予約
            </a>

            {/* ハンバーガー */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer text-gray-800"
              aria-label="メニュー"
            >
              <i className={`fa-solid ${menuOpen ? 'fa-xmark' : 'fa-bars'} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* モバイルメニュー */}
      <div
        className={`md:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 py-4 space-y-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleAnchorClick(link.href);
              }}
              className="block text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 py-3 px-2 rounded-lg transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <div className="pt-4 border-t border-gray-100">
            <a
              href="tel:05018094594"
              className="flex items-center gap-2 text-sm font-medium text-gray-700 py-2 px-2 cursor-pointer"
            >
              <i className="fa-solid fa-phone text-sm"></i>
              050-1809-4594
            </a>
            <a
              href={RESERVATION_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-2 text-center text-white text-sm font-medium py-3 rounded-lg cursor-pointer hover:opacity-90"
              style={{ backgroundColor: '#3E5F8F' }}
            >
              ご相談予約
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}